import { cn } from '@cobliteam/ui/utils';
import type React from 'react';
import PageHeaderActions from './components/PageHeaderActions';
import PageHeaderTitle from './components/PageHeaderTitle';

export interface PageHeaderProps {
  children: React.ReactNode;
  className?: string;
}

const PageHeader = ({ children, className }: PageHeaderProps) => {
  return <div className={cn('flex w-full tablet:flex-row flex-col justify-between gap-5', className)}>{children}</div>;
};

PageHeader.Title = PageHeaderTitle;
PageHeader.Actions = PageHeaderActions;

export default PageHeader;
